<template>
  <div class="orders">
    <div class="orders-heading">
      <h2>{{ trans.text.orders.title }}</h2>
      <p>{{ trans.text.orders.info }}</p>
    </div>

    <div class="orders-list">
      <div class="orders-item">
        <cart
          v-for="order in filteredOrders"
          v-if="allStatuses"
          :key="`order-${order.id}`"
          :order="order"
          :statuses="allStatuses"
          :trans="trans"
          :needCollapse="filteredOrders.length > 1"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import OrderItemComponent from './OrderItemComponent'

export default {
  props: ['trans'],
  components: {
    cart: OrderItemComponent
  },
  data() {
    return {}
  },
  mounted() {
    this.loadOrders();
  },
  computed: {
    ...mapGetters(['allOrders', 'allStatuses', 'storage']),
    orders() {
      return this.allOrders
    },
    filteredOrders() {
      return this.allOrders.filter(item => {return item.basket !== null})
    },
    language() {
      return this.$store.state.language.language;
    }
  },
  methods: {
    ...mapActions(['GetOrders']),
    loadOrders() {
      this.GetOrders({
        path: this.$path
      }).catch(err => {
        alert(err);
      });
    }
  }
}
</script>
